<mat-expansion-panel
  class="info-panel remove-mat-expansion-panel-padding"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  [expanded]="panelOpenState">

  <mat-expansion-panel-header #sectionHeader>
    <mat-panel-title class="mat-panel-title-hide-toggle">
      <div class="section-header-container">
        <p class="overline grey1 semibold section-title">{{sysText.employeeEntitlement_employeeEntitlement}}</p>
        <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="main-content">
    @if (showEntitlements) {
      @if (canChange) {
        <div class="add-button-container">
          <button
            (click)="onAddEntitlement()"
            mat-flat-button
            color="accent"
            class="button"
            [disabled]="(isLoadingEntitlementDialog$ | async)">
            {{ isCaseDetails && (isMicro$ | async) ? sysText.employeeEntitlement_add_small : sysText.employeeEntitlement_add }}
          </button>
          @if (isCaseDetails) {
            <button
              (click)="onCalcEntitlement()"
              mat-flat-button
              color="accent"
              class="button"
              [disabled]="!canCalc || (isLoadingCalcEntitlementDialog$ | async)">
              {{ (isMicro$ | async) ? sysText.employeeEntitlement_calc_small : sysText.employeeEntitlement_calc }}
            </button>
          }
          @if ((isLoadingEntitlementDialog$ | async)) {
            <mat-spinner class="add-spinner" [diameter]="30" color="accent"></mat-spinner>
          }
        </div>
      }
      @if (_ee.data == null || _ee.data.length == 0) {
        <p class="grey2 no_ee">{{sysText.employeeEntitlement_noEntitlementMessage}}</p>
      }
      @if (_ee.data.length > 0) {
        <div [ngClass]="{ 'make-scroll': !(isMobile$ | async) }" class="table-container">
          <table mat-table [dataSource]="_ee" [trackBy]="trackByEntitlementId" multiTemplateDataRows id="data-table">
            <!-- Effective Date Column -->
            <ng-container matColumnDef="effectiveDate">
              <th mat-header-cell *matHeaderCellDef>
                <span>{{sysText.employeeEntitlement_effectiveDate | titlecase}}</span>
              </th>
              <td mat-cell *matCellDef="let ee">
                @if ((ee | astype: eeType).effectiveDate != null) {
                  <span class="grey1">{{(ee | astype: eeType).effectiveDate | date}}</span>
                } @else {
                  --
                }
              </td>
            </ng-container>
            <!-- Bank Column -->
            <ng-container matColumnDef="bank">
              <th mat-header-cell *matHeaderCellDef>
                <span>{{sysText.employeeEntitlement_bank | titlecase}}</span>
              </th>
              <td mat-cell *matCellDef="let ee">
                <span>{{
                  (ee | astype: eeType).bank === banks.Bank1 ? (leaveHoursBanks.bank1Name ?? leaveHoursBanks.bank1DefaultName) :
                  (ee | astype: eeType).bank === banks.Bank2 ? (leaveHoursBanks.bank2Name ?? leaveHoursBanks.bank2DefaultName) :
                  (ee | astype: eeType).bank === banks.Bank3 ? (leaveHoursBanks.bank3Name ?? leaveHoursBanks.bank3DefaultName) :
                  (ee | astype: eeType).bank === banks.Bank4 ? (leaveHoursBanks.bank4Name ?? leaveHoursBanks.bank4DefaultName) :
                  (ee | astype: eeType).bank === banks.Bank5 ? (leaveHoursBanks.bank5Name ?? leaveHoursBanks.bank5DefaultName) : '--'}}
                </span>
              </td>
            </ng-container>
            <!-- Total Hours Column -->
            <ng-container matColumnDef="totalHours">
              <th mat-header-cell *matHeaderCellDef>
                <span>{{sysText.employeeEntitlement_totalHours | titlecase}}</span>
              </th>
              <td mat-cell *matCellDef="let ee">
                <span>{{(ee | astype: eeType).totalHours}}</span>
              </td>
            </ng-container>
            <!-- Cases With Leaves -->
            <ng-container matColumnDef="casesWithLeaves">
              <th mat-header-cell *matHeaderCellDef>
                <span>{{sysText.employeeEntitlement_casesWithLeaves | titlecase}}</span>
              </th>
              <td mat-cell *matCellDef="let ee">
                @if ((ee | astype: eeType).casesWithLeaves?.length > 0) {
                  <div class="case-container">
                    @for (case of (ee | astype: eeType).casesWithLeaves; track $index) {
                      @if (case != caseNumber) {
                        <a [routerLink]="'/' + routes.CASE_DETAILS + '/' + case">{{case}}</a>
                      } @else {
                        <span>{{case}}</span>
                      }
                      @if (((ee | astype: eeType).casesWithLeaves.length > 1 && $index != (ee | astype: eeType).casesWithLeaves.length -1) ) {
                        <span>{{", "}}</span>
                      }
                    }
                  </div>
                } @else {
                  --
                }
              </td>
            </ng-container>
            <!-- Leaves Taken -->
            <ng-container matColumnDef="leavesTaken">
              <th mat-header-cell *matHeaderCellDef>
                <span>{{sysText.employeeEntitlement_leavesTaken}}</span>
              </th>
              <td mat-cell *matCellDef="let ee">
                @if ((ee | astype: eeType).leavesTaken != null) {
                  <span>{{(ee | astype: eeType).leavesTaken}}</span>
                } @else {
                  --
                }
              </td>
            </ng-container>
            <!-- Leave Hours Taken -->
            <ng-container matColumnDef="leaveHoursTaken">
              <th mat-header-cell *matHeaderCellDef>
                <span>{{sysText.employeeEntitlement_leaveHoursTaken}}</span>
              </th>
              <td mat-cell *matCellDef="let ee">
                @if ((ee | astype: eeType).leaveHoursTaken != null) {
                  <span>{{(ee | astype: eeType).leaveHoursTaken}}</span>
                } @else {
                  --
                }
              </td>
            </ng-container>
            <!--Icons Column -->
            <ng-container matColumnDef="icons" stickyEnd>
              <th mat-header-cell *matHeaderCellDef>
              </th>
              <td mat-cell *matCellDef="let ee" class="mat-cell-action-buttons">
                @if (canChange) {
                  <!-- the icons stay while a delete runs: delete keeps focus with the spinner over its icon (show-progress) and
                  its guard blocks clicks, the rest grey out -->
                  @let busy = isSubmittingId != null;
                  @let deleting = isSubmittingId === (ee | astype: eeType).employeeBankTotalHoursId;
                  <div class="icons">
                    <button
                      type="button"
                      class="button-reset"
                      [class.show-progress]="deleting"
                      [disabled]="busy && !deleting"
                      [attr.aria-label]="deleting ? sysText.submitting_ariaLabel : sysText.delete_ariaLabel"
                      (click)="!busy && onDeleteEntitlement(ee.employeeBankTotalHoursId)">
                      <mat-icon color="accent">delete</mat-icon>
                      @if (deleting) {
                        <mat-spinner diameter="20" color="accent"></mat-spinner>
                      }
                    </button>
                    <button
                      type="button"
                      class="button-reset"
                      [disabled]="busy"
                      [attr.aria-label]="sysText.edit_ariaLabel"
                      (click)="onEditEntitlement(ee)">
                      <mat-icon color="accent">edit</mat-icon>
                    </button>
                  </div>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let doc; columns: displayedColumns"></tr>
          </table>
        </div>
      } @else {
        <p class="grey2 no-schedule-msg">{{sysText.employeeEntitlement_no_entitlement}}</p>
      }
    } @else {
      <p class="grey2 no_ee">{{sysText.employeeEntitlement_noEntitlementContext}}</p>
    }
  </div>
</mat-expansion-panel>

